<template>
  <div style="width: 100%;" :class="ISphone ? smallh2label : bigh2label">
    <!--    图片 -->

    <div v-if="ISphone" class="fx-column fx-row-center">
      <!-- img_yuetoutiao_img_banner_qrcode2.jpg -->
      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_img_banner_qrcode2.jpg"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_img_rego_ph.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_img_content_ph.png"
        style="width: 100vw;"
      />

      <img
        v-if="ISphone"
        src="http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_img_personal_ph.png"
        style="width: 100vw;"
      />
    </div>
    <div v-else>
      <div
        class="downloadiconview fx-column fx-row-center fx-row-middle"
        style="width: 100vw;height: 43vw;margin-top:2px;"
      >
        <div class="scale_bg erqodeview fx-column fx-row-center">
          <img
            src="../assets/download2.png"
            style="background:white; padding:10px; border-radius:5px; width:10vw; "
          />
          <div
            :class="ISphone ? smallh3label : bigh3label"
            style="color:white; margin-top:5px;"
          >扫描下载悦头条</div>
        </div>
      </div>

      <!--   选项  -->
      <div class="fx-column fx-row-center" style=" width: 100vw;">
        <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">简单认识悦头条</div>

        <div class="blueline"></div>

        <div
          style="margin-top: 3vw;margin-bottom: 4vw; width: 50vw; "
        >聚合数万个资讯网站的精选内容，你想看的尽在悦头条悦头条作为愉悦推自有媒体，有丰富的信息流广告投放经验，服务优势突出</div>

        <div
          class="fx-row fx-row-center fx-row-space-around"
          style="width: 90%;  margin-bottom: 5vw;"
        >
          <div
            class="fx-column fx-row-center descell"
            v-bind:style="ISphone ? { height: 45 + 'vw',  width: 25 + 'vw' } : { height: 25 + 'vw',  width: 25 + 'vw' }"
            v-for="(item, index) in dataarray1"
            v-bind:key="index"
          >
            <img :src="item.iconurl" style="width: 8vw;height: 8vw;margin-top: 5vw;" />
            <div
              :class="ISphone ? smallh2label : 'pxlabel_20'"
              style="margin-top: 3vw; font-weight: middle;color:#16214B; "
            >{{ item.titlestr }}</div>
            <div
              :class="ISphone ? smallh2label : 'pxlabel_14'"
              style="margin-top: 1vw; width:90%; color:#515978;"
            >{{ item.desstr }}</div>
          </div>
        </div>
      </div>

      <!--    优质原创内容 height: 48vw;-->
      <div class="youzhiview fx-column fx-row-center" style="width: 100vw; ">
        <div
          :class="ISphone ? smallh1label : bigh1label"
          style="margin-top: 5vw; color: white;"
        >优质原创内容</div>
        <div class="blueline"></div>

        <div style="margin-top:2.5vw; color: white; ">日均发稿量百万篇，日均视频量十万个</div>

        <div
          class="fx-row fx-row-center fx-row-space-around"
          style="width: 80%; margin-top: 3vw; margin-bottom: 10vw;"
        >
          <div
            class="fx-column fx-row-center"
            v-for="(item, index) in dataarray2"
            v-bind:key="index"
          >
            <img :src="item.iconurl" style="width: 10vw; height: 10vw;margin-top: 5vw;" />
            <div
              :class="ISphone ? smallh2label : 'pxlabel_20'"
              style="margin-top: 2vw;  color: white;"
            >{{ item.titlestr }}</div>
          </div>
        </div>
      </div>

      <!--    个性化推荐  height: 48vw;  -->

      <div class="fx-column fx-row-center" style="width: 100vw; ">
        <div
          :class="ISphone ? smallh1label : bigh1label"
          style="margin-top: 4vw; color: black;"
        >个性化推荐</div>
        <div class="blueline"></div>

        <div
          style="margin-top:2.5vw;  width:30vw; color;#515978;"
          :class="ISphone ? smallh2label : 'pxlabel_14'"
        >依托于精准的算法推荐系统，机器学习专家为您量身打造舒适阅读服务，悦头条为您推荐专属优质阅读内容</div>

        <div
          class="fx-row fx-row-center fx-row-space-around"
          style="width: 80%;  margin-bottom: 6vw;"
        >
          <div
            style="border-radius:1.5vw; overflow: hidden; margin-top: 4vw;  "
            class="fx-column fx-row-center hvr_grow_shadow"
            v-for="(item, index) in dataarray3"
            v-bind:key="index"
          >
            <img class :src="item.iconurl" style="width: 25vw;height: 18vw;  " />
          </div>
        </div>
      </div>
    </div>
    <!--    联系我们  -->

    <contactusview />
  </div>
</template>
<script type="text/ecmascript-6">
import contactusview from "@/components/contactusview.vue";

export default {
  name: "Headlines",
  components: {
    contactusview
  },
  data() {
    return {
      ISphone: false,

      bigh1label: "bigh1label",
      bigh2label: "bigh2label",
      bigh3label: "bigh3label",
      smallh1label: "smallh1label",
      smallh2label: "smallh2label",
      smallh3label: "smallh3label",
      dataarray1: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_img_konw_fir.png",
          titlestr: "用户粘性高",
          desstr: "培养用户阅读习惯，让用户爱上阅读"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_img_konw_sec.png",
          titlestr: "人群消费升级",
          desstr: "从一二线覆盖到三四线，深挖消费升级用户群"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_img_konw_thir.png",
          titlestr: "精准算法推荐",
          desstr: "强大的机器学习算法，实现内容精准推荐"
        }
      ],
      dataarray2: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_img_content_fir.png",
          titlestr: "原创"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_img_content_sec.png",
          titlestr: "创意"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_img_content_thir.png",
          titlestr: "及时"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_img_content_four.png",
          titlestr: "海量"
        }
      ],
      dataarray3: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_img_commend_fir.png"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_img_commend_sec.png"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_img_commend_thir.png"
        }
      ]
    };
  },
  mounted() {
    this.ISphone = this.$appdata.ISphone;
  },
  methods: {
    /**
     * 点击事件
     */
    /**
     * 网络请求
     */
    /**
     * 业务方法
     */
    /**
     * 回调方法
     */
    /**
     * 页面私有方法
     */
  }
};
</script>
<style lang="less" scoped>
/*页面公共样式*/
.descell {
  background: #ffffff;
  border: 1px solid #7f859c;
  border-radius: 8px;
  // width: 25vw;
  // height: 28.5vw;
}
/*头部*/

.youzhiview {
  background: url("http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_bg_content.png")
    no-repeat;
}

.downloadiconview {
  background-image: url("http://pic.midongtech.xyz/yytgw/assets/img_yuetoutiao_img_banner.jpg");
  // background: no-repeat center top;
  background-size: contain;
}

.erqodeview {
  // width: 20%;
  // height: 40%;
  // background: red;
  margin-top: 20%;
  margin-right: 50%;
}
/*列表*/

// 鼠标悬停放大图片
// .scale_bg {
//   border: #000 solid 0px;
// }
.scale_bg img {
  cursor: pointer;
  transition: all 0.6s;
}
.scale_bg img:hover {
  transform: scale(1.4);
}
</style>
